import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { KeyboardEventService } from '../services/keyboard-event.service';



const TOKEN_HEADER_KEY = 'Authorization';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private eventService: KeyboardEventService) { }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        let authreq = request;
        const token = localStorage.getItem('name')
        if (token != null) {
            let userInfo = JSON.parse(token || '{}');
            authreq = request.clone({ headers: request.headers.set(TOKEN_HEADER_KEY, 'Bearer ' + userInfo['accessToken']) });
        }
        return next.handle(authreq).pipe(
            catchError((error) => {
                if (error.status == 401) {
                    localStorage.removeItem('name')
                    this.eventService.emitCustomEvent('F8');
                }
                return throwError(() => error);
            })
        );
    }
}

export const authInterceptorProviders = [{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }];
